export const GET_CURRENT_GEOLOCATION = 'geolocation/GET_CURRENT_GEOLOCATION';
export const SET_CURRENT_GEOLOCATION = 'geolocation/SET_CURRENT_GEOLOCATION';
export const USE_STORED_LOCATION = 'geolocation/USE_STORED_LOCATION';
